import { render, staticRenderFns } from "./updatedSiteHeader.vue?vue&type=template&id=804ebabc&scoped=true"
import script from "./updatedSiteHeader.vue?vue&type=script&lang=js"
export * from "./updatedSiteHeader.vue?vue&type=script&lang=js"
import style0 from "./updatedSiteHeader.vue?vue&type=style&index=0&id=804ebabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804ebabc",
  null
  
)

export default component.exports